import { MANAGING_MONITORING_PRICING_LEVEL_TITLE } from '@app/api/constants'

import type { ManagingMonitoringsDataSource } from '@app/pages/ManagingMonitoringsPage/types'
import type { TableData } from '@app/types/table'
import type { ResponseDto } from '@app/api/dtos'
import type { ManagingTypeDto } from '@app/api/routes/monitorings/dtos'

type PricingLevelKey = keyof typeof MANAGING_MONITORING_PRICING_LEVEL_TITLE

export const adaptManagingMonitoringsTableData = (
  managingTypeResponse: ResponseDto<ManagingTypeDto>
): TableData<ManagingMonitoringsDataSource> => {
  const { count, results: managingType } = managingTypeResponse

  const dataSource: ManagingMonitoringsDataSource[] = managingType.map(dto => ({
    key: dto.id,
    id: dto.id,
    monitoringType: dto.name,
    monitoringKind: dto.monitoringKind.name,
    pricingLevel: MANAGING_MONITORING_PRICING_LEVEL_TITLE[dto.pricingLevel as PricingLevelKey],
    isActive: dto.isActive
  }))

  return { count, dataSource }
}
